/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import SupplierDto from './SupplierDto';

/**
 * The SearchingQueryResponseModelSupplierDto model module.
 * @module model/SearchingQueryResponseModelSupplierDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelSupplierDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelSupplierDto</code>.
     * @alias module:model/SearchingQueryResponseModelSupplierDto
     */
    constructor() { 
        
        SearchingQueryResponseModelSupplierDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelSupplierDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelSupplierDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelSupplierDto} The populated <code>SearchingQueryResponseModelSupplierDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelSupplierDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [SupplierDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelSupplierDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/SupplierDto>} result
 */
SearchingQueryResponseModelSupplierDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelSupplierDto;

